import Vue from 'vue'
import VueCookies from 'vue-cookies'

import store from './store'

import LoginForm from './components/LoginForm.vue'
import CalendarMonth from './components/CalendarMonth.vue'
import TimerBox from './components/TimerBox.vue'
import TimerLandingPageBox from './components/TimerLandingPageBox.vue'
import CookieConsent from './components/CookieConsent.vue'

const UJS_COMPONENTS = {
  LoginForm,
  CalendarMonth,
  TimerBox,
  TimerLandingPageBox,
  CookieConsent,
}

const initComponent = (container) => {
  const componentName = container.getAttribute('data-component')
  const component = UJS_COMPONENTS[componentName]

  let props = {}
  if (container.getAttribute('data-props')) {
    props = JSON.parse(container.getAttribute('data-props'))
  } else if (container.getAttribute('data-props-global')) {
    props = window[container.getAttribute('data-props-global')]
  }

  if (component) {
    Vue.use(VueCookies, { expires: Infinity })
    new Vue({
      store,
      render: (h) => h(component, { props }),
    }).$mount(container)
  } else {
    console.error('Unknown component name: ' + componentName)
  }
}

const componentContainers = document.querySelectorAll('[data-component]')
for (let i = 0; i < componentContainers.length; ++i) {
  initComponent(componentContainers[i])
}



// WEBPACK FOOTER //
// ./src/initComponents.js